// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1dPdh","footer":"ModalCreateQualiphyProcedure_footer__vRe-E","additionData":"ModalCreateQualiphyProcedure_additionData__2tKC0"};